import React, { PureComponent } from 'react';
import { ISession } from 'types';
// Components
import Button from 'ui/button';

interface SessionConditionsProps {
  session: ISession;
}

const CONDITIONS = {
  wind: ['No wind', 'Windy', 'Very windy'],
  wave: ['Flat', 'Choppy', 'Waves']
};

export default class SessionConditions extends PureComponent<SessionConditionsProps> {
  renderGroup(key: string, selected: number) {
    return (
      <div key={key} className="tiny-margin">
        {CONDITIONS[key].map((label, index) => (
          <Button
            key={index}
            flat={label}
            raised={index === selected}
            onClick={() => this.props.onChange({ ...this.props.session.conditions, [key]: index })}
          />
        ))}
      </div>
    );
  }
  render() {
    const { session } = this.props;

    const conditions = session.conditions || {};
    const groups = [];
    for (let key in CONDITIONS) {
      groups.push(this.renderGroup(key, conditions[key] || 0));
    }
    return groups;
  }
}
